import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';
import { environment } from 'src/environments/environment';
// import { GLOBAL_VARIABIALES } from 'src/app/shared/constants/StaticVariable';
// declare var Razorpay:any;

@Component({
  selector: 'app-price-component',
  templateUrl: './price-component.component.html',
  styleUrls: ['./price-component.component.scss'],
})
export class PriceComponentComponent implements OnInit {
  onSession: boolean;
  emailId: String;
  userExistError: boolean;
  packages: any;

  constructor(
    private loginSignupService: LoginSignupService,
    private toastService: ToastService,
    private router: Router,
    private tansactionService: TansactionService
  ) {
    this.onSession = Boolean(
      this.loginSignupService.getUserSession()?.user?.onSession
    );
    this.emailId = this.loginSignupService.getUserSession()?.user?.email;
    // console.log(this.onSession);
  }

  ngOnInit(): void {
    this.currentPrice();
  }

  currentPrice() {
    this.tansactionService
      .currentPrice()
      .then((data: any) => {
        this.packages = data;
      })
      .catch((err: any) => {});
  }

  purchasedPlan(category) {
    this.cartPlan(category);
  }

  registered() {
    this.router.navigate(['/user/signup']);
  }

  // updateCart(category) {
  //   let currentOption;
  //   let startDate = new Date();
  //   currentOption = {
  //     id: this.cartData._id,
  //     email: this.emailId,
  //     startdate: startDate,
  //     enddate: startDate.setDate(startDate.getDate() + 30),
  //     category: category,
  //     status: 'open',
  //     mobile: this.commonService.getUserSession().user.mobile,
  //   };
  //   this.companyService.updateCartPayOut(currentOption).then(
  //     (data: any) => {
  //       if (data.message == "Success") {

  //       }
  //     },
  //     (err) => {
  //       this.toastService.addSingle("error", "Error", err.error.message);
  //     }
  //   );

  // }

  disableButtons = false;

  cartPlan(category) {
    this.disableButtons = true;
    let currentOption;
    let startDate = new Date();
    currentOption = {
      email: this.emailId,
      startdate: startDate,
      enddate: startDate.setDate(startDate.getDate() + 30),
      category: category,
      status: 'open',
      // mobile:this.commonService.getUserSession().user?.mobile,
    };
    this.tansactionService.createCartPayOut(currentOption).then(
      (data: any) => {
        // show waiting for payment text
        // window.open(data.razor_sub.short_url);
        this.router.navigate(['cart']);
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }

  contactSales(){
    window.location.href = 'mailto:sales@thekredible.in';
  }
}
